// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-left-end-on-rectangle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-left-end-on-rectangle',
  version: 'solid',
  paths: [
    {
      d: 'M3.6 5.1a2.7 2.7 0 0 1 2.7-2.7h6.6a2.7 2.7 0 0 1 2.7 2.7v2.4a.9.9 0 0 1-1.8 0V5.1a.9.9 0 0 0-.9-.9H6.3a.9.9 0 0 0-.9.9v13.8c0 .4968.4032.9.9.9h6.6a.9.9 0 0 0 .9-.9v-2.4a.9.9 0 0 1 1.8 0v2.4a2.7 2.7 0 0 1-2.7 2.7H6.3a2.7 2.7 0 0 1-2.7-2.7V5.1',
      fillRule: 'evenodd',
    },
    {
      d: 'M22.8 12a.9.9 0 0 0-.9-.9H10.4448l1.2576-1.1316a.9.9 0 1 0-1.2048-1.3368l-3 2.7a.9.9 0 0 0 0 1.3368l3 2.7a.9.9 0 1 0 1.2048-1.3368L10.4448 12.9H21.9a.9.9 0 0 0 .9-.9',
      fillRule: 'evenodd',
    },
  ],
}
